import type { TFunction } from 'i18next';

import { DefaultApi } from '../autogenerated/pokApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { TKeys } from '../../hooks/useTranslation';
import { downloadDocumentsForGrid } from '../../../pok/components/DownloadDocuments/DownloadDocumentsSearch';

export interface DownloadDocumentsContextInterface {
  getAllByPortion: (
    t: TFunction<'commonLng', 'commonLng'>,
    tk: TKeys<'commonLng'>,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    filterOnlyCurrentUser?: boolean,
  ) => Promise<GridRecord[]>;
  getAllCount: (
    filterText?: string,
    filterColumns?: string,
    filterOnlyCurrentUser?: boolean,
  ) => Promise<number>;
  getZipByName: (fileName: string) => Promise<Blob>;
}

export const DownloadDocumentsContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      t: TFunction<'commonLng', 'commonLng'>,
      tk: TKeys<'commonLng'>,
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
      filterOnlyCurrentUser?: boolean,
    ) => {
      const data = await api.downloadsDocumentsControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
        filterOnlyCurrentUser,
      );
      return data.map(item => downloadDocumentsForGrid(t, tk, item));
    },
    getAllCount: (
      filterText?: string,
      filterColumns?: string,
      filterOnlyCurrentUser?: boolean,
    ) =>
      api.downloadsDocumentsControllerGetAllCount(
        filterText || '',
        filterColumns,
        filterOnlyCurrentUser,
      ),
    getZipByName: (fileName: string) =>
      api.downloadsDocumentsControllerGetZipByName(fileName),
  };
};
